import cn from 'classnames';
import { useAnalytics } from 'src/hooks/useAnalytics';

import s from './ChipsFilter.module.scss';
import { Variant } from './constants';

export interface ChipsFilterProps {
  id: string;
  label: string;
  className?: string;
  variant?: Variant;
  onClick: (id: string) => void;
  isActive?: boolean;
  isDisabled?: boolean;
}

export function ChipsFilter({
  id,
  label,
  onClick,
  className = '',
  variant = Variant.Primary,
  isActive = false,
  isDisabled = false,
}: ChipsFilterProps) {
  const { clickAnalytics } = useAnalytics();

  const handleClick = () => {
    onClick(id);

    clickAnalytics({
      action: 'click',
      clickZone: 'body',
      clickElement: 'buttonclick',
      clickContent: `chips-filter-${label}`,
      uniqueId: `chips-filter-${label}`,
      transitionType: 'inside-link',
    });
  };

  const classNames = cn(
    s.root,
    s[variant],
    { [s.active]: isActive, [s.disabled]: isDisabled },
    className,
  );

  return (
    <button className={classNames} onClick={handleClick}>
      {label}
    </button>
  );
}

ChipsFilter.variants = Variant;
